import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react'
import { ProcessFlowDiagramBuilderContext } from 'features/processFlowDiagrams/contexts/ProcessFlowDiagramBuilderContext'
import React, { useContext } from 'react'
import { PfdEdgeProps } from 'types'

import { getEdgeSelectionStyle } from './SolidLine'
import { SwapEdgeButton } from './SwapEdgeButton'

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {
    strokeWidth: 1,
    stroke: 'gray',
    strokeDasharray: '5 5',
  },
  markerEnd,
  markerStart,
  data,
}: PfdEdgeProps) {
  const { selectedEdge } = useContext(ProcessFlowDiagramBuilderContext)
  const selected = selectedEdge?.id === id
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    stepPosition: 1,
    targetPosition,
    borderRadius: 0,
    centerX: targetX,
  })

  const edgeStyle = getEdgeSelectionStyle(selected, style)

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={edgeStyle}
      />
      {!data?.confirmedEdge && (
        <EdgeLabelRenderer>
          <SwapEdgeButton labelX={labelX} labelY={labelY} id={id} />
        </EdgeLabelRenderer>
      )}
    </>
  )
}
